import { render, staticRenderFns } from "./text-numeric-prop.vue?vue&type=template&id=07f95545&scoped=true&"
import script from "./text-numeric-prop.vue?vue&type=script&lang=js&"
export * from "./text-numeric-prop.vue?vue&type=script&lang=js&"
import style0 from "./text-numeric-prop.vue?vue&type=style&index=0&id=07f95545&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f95545",
  null
  
)

component.options.__file = "text-numeric-prop.vue"
export default component.exports